import Vue from "vue";

export default Vue.extend({
    name: "DnSelect",
    props: {
        id: {
            type: String,
            default: ""
        },
        list: {
            type: Array,
            default: () => []
        },
        extraClasses: {
            type: String,
            default: ""
        },
        default: {
            type: Object,
            default: () => null
        },
        size: {
            type: String,
            default: ""
        },
        placeholderText: {
            type: String,
            default: ""
        }
    },
    computed: {
        classes() {
            return `form-control ${this.setSize()} ${this.extraClasses}`;
        }
    },
    created() {
        this.selectModel = this.default;
        this.setSize();
    },
    data: () => ({
        selectModel: {}
    }),
    methods: {
        setDefault() {
            this.selectModel = this.default;
            this.updateValue();
        },
        updateValue() {
            this.$emit("input", this.selectModel);
        },
        setSize() {
            switch (this.size) {
                case "small":
                    return "dn-select__small";
                default:
                    break;
            }
        }
    },
    watch: {
    },
});
